import { ApiResponse } from "../types/api";
import { ChartPlotter, ChartPlotterModel } from "../types/integration";
import Base from "./base";

class IntegrationAPI extends Base {
	constructor(token: string) {
		super(token, "/api/integration");
	}

	async getChartPlotterIntegrations(): Promise<ApiResponse<ChartPlotterModel[]>> {
		return await this.fetchJsonWithQueryParams("/chartPlotter", "GET");
	}

	async createChartPlotter(type: ChartPlotter): Promise<ApiResponse<ChartPlotterModel[]>> {
		return await this.postJsonWithQueryParams("/chartPlotter", "POST", { type });
	}
}

export default IntegrationAPI;
